module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 3-922e09bb1638be221b41a26d99fcdaf5.png";